/*
import styled from "styled-components";

//#region Styles
const EachFeature = styled.div`
  display: flex;
  flex-direction: column;
  & p,
  a,
  tr,
  td,
  ul,
  li {
    color: #212b36;
    text-align: left;
    font-family: "Roboto";
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4rem;
    text-decoration: none;
    @media only screen and (max-width: 968px) {
      font-weight: 400;
      font-size: 0.9rem;
    }
    & p {
      color: #1aa6e1;
    }
  }
  & h2 {
    color: #212b36;
    text-align: left;
    font-family: "Roboto Slab";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 0.3rem;
    @media only screen and (max-width: 968px) {
      font-size: 1.1rem;
    }
    & p {
      color: #1aa6e1;

      text-align: left;
      font-family: "Roboto Slab";
      font-size: 2.18rem;
      font-style: normal;
      font-weight: 450;
      line-height: normal;
      @media only screen and (max-width: 968px) {
        font-weight: 450;
        font-size: 1.5rem;
      }
    }
  }  
`;
const LabelDiv = styled.div`
  display: flex;
  flex-direction: row;
  background-color:#1AA6E1;
  margin-bottom:.5rem;
  padding:.2rem 1.5rem;
  & h1 {
    color: #fff;

    text-align: left;
    font-family: "Roboto Slab";
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    @media only screen and (max-width: 968px) {
      font-weight: 500;
      font-size: 1.3rem;
    }
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
//#endregion
function PrivacyPolicyContent() {
  return (
    <EachFeature>
    <LabelDiv>
        <h1>PRIVACY POLICY</h1>
    </LabelDiv>
      <p>
        Best Catering Food Service is a trading name of Best C. Veg Limited and
        we are committed to protecting your right to privacy as an individual.
        This affects you, not only if you are running your own business as a
        sole trader, or as a partner, but also if you are an employee.
      </p>
      <br />
      <p>
        This privacy policy sets out how Best C. Veg Limited Catering uses and
        protects any information that you give Best C. Veg Limited when you use
        this website. Best C. Veg Limited is committed to ensuring that your
        privacy is protected. Should we ask you to provide certain information
        by which you can be identified when using this website, then you can be
        assured that it will only be used by this privacy statement. Best C. Veg
        Limited may change this policy from time to time by updating this page.
        You should check this page from time to time to ensure that you are
        happy with any changes.
      </p>
      <br />
      <h2>What we collect</h2>
      <p>
        When you place an order, we need to know your name, billing address,
        trading address, email address, and telephone number so that we can
        process your order and get back to you if we have any queries.
      </p>
      <ul>
        <li>Name</li>
        <li>Contact information including email address</li>
        <li>
          Demographic information such as postcode, preferences, and interests
        </li>
        <li>Other information relevant to customer surveys and/or offers</li>
      </ul>
      <br />
      <h2>What we do with the information we gather</h2>
      <p>
        We require this information to understand your needs and provide you
        with a better service, and for the following reasons:
      </p>
      <ul>
        <li>Internal record keeping.</li>
        <li>
          We may use the information to improve our products and services.
        </li>
        <li>
          We may periodically send promotional emails about new products,
          special offers, or other information that we think you may find
          interesting using the email address that you have provided.
        </li>
        <li>
          From time to time, we may also use your information to contact you for
          market research purposes. We may contact you by email, phone, fax, or
          mail. We may use the information to customize the website according to
          your interests.
        </li>
      </ul>
      <br />
      <h2>Security</h2>
      <p>
        We are committed to ensuring that your information is secure. To prevent
        unauthorized access or disclosure, we have put in place suitable
        physical, electronic, and managerial procedures to safeguard and secure
        the information we collect online. We may have to disclose your
        information to third-party contractors to process your order, however,
        it will not be disclosed to any organization outside Best C. Veg Limited
        for any purpose other than for the execution of your order.
      </p>
      <br />
      <h2>How we use cookies</h2>
      <p>
        A cookie is a small file that asks permission to be placed on your
        computer's hard drive. Once you agree, the file is added, and the cookie
        helps analyse web traffic or lets you know when you visit a particular
        site. Cookies allow web applications to respond to you as an individual.
        The web application can tailor its operations to your needs, likes, and
        dislikes by gathering and remembering information about your
        preferences.
      </p>
      <br />
      <p>
        We use traffic log cookies to identify which pages are being used. This
        helps us analyse data about web page traffic and improve our website to
        tailor it to customer needs. We only use this information for
        statistical analysis purposes and then the data is removed from the
        system.
      </p>
      <br />
      <p>
        Overall, cookies help us provide you with a better website, by enabling
        us to monitor which pages you find useful and which you do not. A cookie
        in no way gives us access to your computer or any information about you,
        other than the data you choose to share with us. You can choose to
        accept or decline cookies. Most web browsers automatically accept
        cookies, but you can usually modify your browser settings to decline
        cookies if you prefer. This may prevent you from taking full advantage
        of the website.
      </p>
      <br />
      <h2>Links to other websites</h2>
      <p>
        Our website may contain links to other websites of interest. However,
        once you have used these links to leave our site, you should note that
        we do not have any control over that other website. Therefore, we cannot
        be responsible for the protection and privacy of any information that
        you provide whilst visiting such sites, and such sites are not governed
        by this privacy statement. You should exercise caution and look at the
        privacy statement applicable to the website in question.
      </p>
      <br />
      <h2>Controlling your personal information</h2>
      <p>
        You may choose to restrict the collection or use of your personal
        information in the following ways:
      </p>
      <br />
      <ul>
        <li>
          Whenever you are asked to fill in a form on the website, look for the
          box that you can click to indicate that you do not want the
          information to be used by anybody for direct marketing purposes.
        </li>
        <li>
          If you have previously agreed to us using your personal information
          for direct marketing purposes, you may change your mind at any time by
          writing to or emailing us at{" "}
          <a href="mailto:sales@bestcateringuk.com">sales@bestcateringuk.com</a>
          .
        </li>
      </ul>
      <br />
      <p>
        We will not sell, distribute, or lease your personal information to
        third parties unless we have your permission or are required by law to
        do so. We may use your personal information to send you promotional
        information about third parties which we think you may find interesting
        if you tell us that you wish this to happen.
      </p>
      <br />
      <p>
        You may request details of personal information which we hold about you
        under the Data Protection Act 1998. A small fee will be payable. If you
        would like a copy of the information held on you, please write to Best
        C. Veg Limited Unit 5-9 Leeside Industrial Estate Garman Road,
        Tottenham, London N17 0QH.
      </p>
      <br />
      <p>
        If you believe that any information we are holding on you is incorrect
        or incomplete, please write to or email us as soon as possible, at the
        above address. We will promptly correct any information found to be
        incorrect.
      </p>
      <br />
      <h2>List of cookies we collect</h2>
      <p>
        The table below lists the cookies we collect and what information they
        store.
      </p>
      <br />
      <table border="1">
        <thead>
          <tr>
            <th>COOKIE Name</th>
            <th>COOKIE Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>CART</td>
            <td>The association with your shopping cart.</td>
          </tr>
          <tr>
            <td>CATEGORY_INFO</td>
            <td>
              Stores the category info on the page, which allows to display of
              pages more quickly.
            </td>
          </tr>
          <tr>
            <td>COMPARE</td>
            <td>The items that you have in the Compare Products list.</td>
          </tr>
          <tr>
            <td>CURRENCY</td>
            <td>Your preferred currency.</td>
          </tr>
          <tr>
            <td>CUSTOMER</td>
            <td>An encrypted version of your customer ID with the store.</td>
          </tr>
          <tr>
            <td>CUSTOMER_AUTH</td>
            <td>An indicator if you are currently logged into the store.</td>
          </tr>
          <tr>
            <td>CUSTOMER_INFO</td>
            <td>An encrypted version of the customer group you belong to.</td>
          </tr>
          <tr>
            <td>CUSTOMER_SEGMENT_IDS</td>
            <td>Stores the Customer Segment ID.</td>
          </tr>
          <tr>
            <td>EXTERNAL_NO_CACHE</td>
            <td>A flag, which indicates whether caching is disabled or not.</td>
          </tr>
          <tr>
            <td>FRONTEND</td>
            <td>You session ID on the server.</td>
          </tr>
          <tr>
            <td>GUEST-VIEW</td>
            <td>Allows guests to edit their orders.</td>
          </tr>
          <tr>
            <td>LAST_CATEGORY</td>
            <td>The last category you visited.</td>
          </tr>
          <tr>
            <td>LAST_PRODUCT</td>
            <td>The most recent product you have viewed.</td>
          </tr>
          <tr>
            <td>NEW MESSAGE</td>
            <td>Indicates whether a new message has been received.</td>
          </tr>
          <tr>
            <td>NO_CACHE</td>
            <td>Indicates whether it is allowed to use cache.</td>
          </tr>
          <tr>
            <td>PERSISTENT_SHOPPING_CART</td>
            <td>
              A link to information about your cart and viewing history if you
              have asked the site.
            </td>
          </tr>
          <tr>
            <td>POLL</td>
            <td>The ID of any polls you have recently voted in.</td>
          </tr>
          <tr>
            <td>POLLN</td>
            <td>Information on what polls you have voted on.</td>
          </tr>
          <tr>
            <td>RECENTLY COMPARED</td>
            <td>The items that you have recently compared.</td>
          </tr>
          <tr>
            <td>SURF</td>
            <td>Information on products you have emailed to friends.</td>
          </tr>
          <tr>
            <td>STORE</td>
            <td>The store view or language you have selected.</td>
          </tr>
          <tr>
            <td>USER_ALLOWED_SAVE_COOKIE</td>
            <td>Indicates whether a customer is allowed to use cookies.</td>
          </tr>
          <tr>
            <td>VIEWED_PRODUCT_IDS</td>
            <td>The products that you have recently viewed.</td>
          </tr>
          <tr>
            <td>WISHLIST</td>
            <td>An encrypted list of products added to your Wishlist.</td>
          </tr>
          <tr>
            <td>WISHLIST_CNT</td>
            <td>The number of items in your Wishlist.</td>
          </tr>
          <tr>
            <td>GOOGLE ANALYTICS</td>
            <td>
              Google Analytics is a simple, easy-to-use tool that helps website
              owners measure how users interact with website content.
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <h2>Your consent</h2>
      <p>
        By using our website, you consent to us using the personal information
        you provide{" "}
        <a href="http://bestcateringuk.com/">http://bestcateringuk.com/</a> and
        affiliates as set out in this Privacy Policy. If we decide to change our
        Privacy Policy, we will post those changes on this page so that you are
        always aware of the way we collect, use, and disclose information.
      </p>
      <br />
      <h2>Contacting Us</h2>
      <p>
        If you have any questions about this privacy statement, you can contact
        us at{" "}
        <a href="mailto:sales@bestcateringuk.com">sales@bestcateringuk.com</a>{" "}
        or call us on 020 888 555 94.
      </p>
    </EachFeature>
  );
}

export default PrivacyPolicyContent;
*/


import styled from "styled-components";

//#region Styles
const EachFeature = styled.div`
  display: flex;
  flex-direction: column;

  & p,
  a,
  tr,
  td,
  th,
  ul,
  li {
    color: #212b36;
    text-align: left;
    font-family: "Roboto";
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4rem;
    text-decoration: none;

    @media only screen and (max-width: 968px) {
      font-size: 0.9rem;
    }
  }

  & a {
    color: #1aa6e1;
    text-decoration: underline;
  }

  & h2 {
    color: #212b36;
    text-align: left;
    font-family: "Roboto Slab";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: bold;
    line-height: normal;
    margin-top: 1rem;
    margin-bottom: 0.3rem;

    @media only screen and (max-width: 968px) {
      font-size: 1.1rem;
    }
  }

  & ul {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
  }

  & li {
    margin-bottom: 0.4rem;
  }

  & table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  & th,
  td {
    border: 1px solid #dfe3e8;
    padding: 0.75rem;
    vertical-align: top;
  }

  & th {
    background-color: #f4f6f8;
    font-weight: 600;
  }
`;

const LabelDiv = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #1aa6e1;
  margin-bottom: 1rem;
  padding: 0.5rem 1.5rem;

  & h1 {
    color: #fff;
    text-align: left;
    font-family: "Roboto Slab";
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0.5rem 0;

    @media only screen and (max-width: 968px) {
      font-weight: 500;
      font-size: 1.3rem;
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
//#endregion

function PrivacyPolicyContent() {
  return (
    <EachFeature>
      <LabelDiv>
        <h1>BEST CATERING FOOD SERVICE PRIVACY POLICY</h1>
      </LabelDiv>
      <p>
        This Privacy Policy explains how Best C. Veg Limited, trading as Best
        Catering Food Service (&quot;Best Catering&quot;, &quot;we&quot;,
        &quot;our&quot;, or &quot;us&quot;), collects, uses, stores, and
        protects personal information when you use the Best Catering Food
        Service mobile application, our website, and our related ordering
        services.
      </p>

      <br />

      <p>
        The Best Catering Food Service mobile application allows registered
        customers to browse products, view product availability, manage their
        basket, submit orders, review previous orders, and access their customer
        account.
      </p>

      <br />

      <p>
        We are committed to protecting your privacy and processing personal
        information fairly, lawfully, and securely in accordance with the UK
        General Data Protection Regulation, the Data Protection Act 2018, and
        other applicable data protection laws.
      </p>

      <h2>Information We Collect</h2>

      <p>
        We may collect information that you provide directly when you register,
        sign in, contact us, manage your account, or place an order through our
        mobile application or website.
      </p>

      <ul>
        <li>Your name and business or trading name.</li>
        <li>Billing, delivery, and trading addresses.</li>
        <li>Email address and telephone number.</li>
        <li>Customer account and login information.</li>
        <li>Products added to your basket.</li>
        <li>Orders, previous orders, and order-related information.</li>
        <li>Customer-specific prices, discounts, and account preferences.</li>
        <li>
          Information that you provide when contacting customer support.
        </li>
      </ul>

      <h2>Technical and Usage Information</h2>

      <p>
        When you use our website or mobile application, certain technical
        information may be collected automatically to operate, secure, and
        improve our services.
      </p>

      <ul>
        <li>IP address.</li>
        <li>Device type and operating system.</li>
        <li>Browser or application version.</li>
        <li>Session and authentication information.</li>
        <li>Pages, products, and features accessed.</li>
        <li>Error, diagnostic, and performance information.</li>
      </ul>

      <p>
        We do not use the Best Catering Food Service application to collect
        precise location, contacts, photographs, videos, microphone recordings,
        or other device content unless a feature requiring such information is
        introduced and you are informed before collection.
      </p>

      <h2>How We Use Your Information</h2>

      <p>We use personal information for the following purposes:</p>

      <ul>
        <li>To create, authenticate, and manage customer accounts.</li>
        <li>To display products, prices, availability, and discounts.</li>
        <li>To create, process, fulfil, and manage customer orders.</li>
        <li>To provide delivery and customer support services.</li>
        <li>To respond to questions, requests, and complaints.</li>
        <li>To maintain business and transaction records.</li>
        <li>To improve our products, website, and mobile application.</li>
        <li>To detect, prevent, and investigate misuse or security issues.</li>
        <li>To comply with legal, accounting, and regulatory obligations.</li>
        <li>
          To send service-related communications concerning accounts or orders.
        </li>
        <li>
          To send marketing communications where you have provided consent or
          where otherwise permitted by law.
        </li>
      </ul>

      <h2>Legal Basis for Processing</h2>

      <p>
        Depending on the circumstances, we process personal information using
        one or more of the following legal bases:
      </p>

      <ul>
        <li>
          <strong>Contract:</strong> processing required to provide your
          account, process orders, and deliver requested services.
        </li>
        <li>
          <strong>Legal obligation:</strong> processing required to comply with
          tax, accounting, regulatory, or legal requirements.
        </li>
        <li>
          <strong>Legitimate interests:</strong> processing required to operate,
          secure, maintain, and improve our services.
        </li>
        <li>
          <strong>Consent:</strong> processing carried out where you have
          provided clear consent, including certain marketing activities.
        </li>
      </ul>

      <h2>Sharing Your Information</h2>

      <p>
        We do not sell or rent your personal information. We may share
        information with trusted service providers where necessary to operate
        our business and provide requested services.
      </p>

      <ul>
        <li>Delivery and logistics providers.</li>
        <li>Payment and transaction service providers, where applicable.</li>
        <li>Website, application, hosting, and IT service providers.</li>
        <li>Email and customer communication service providers.</li>
        <li>Professional advisers, including accountants and legal advisers.</li>
        <li>
          Government authorities or regulators where disclosure is required by
          law.
        </li>
      </ul>

      <p>
        Service providers may only use personal information for the services
        they provide to us and must protect it appropriately.
      </p>

      <h2>Data Security</h2>

      <p>
        We use appropriate technical and organisational measures designed to
        protect personal information against unauthorised access, alteration,
        disclosure, loss, or destruction.
      </p>

      <p>
        These measures may include access controls, authentication,
        encryption, secure communications, monitoring, backups, and restricted
        access to systems containing personal information.
      </p>

      <p>
        No internet-based system can be guaranteed to be completely secure.
        Customers are responsible for keeping their login credentials
        confidential and should contact us if they believe their account has
        been accessed without permission.
      </p>

      <h2>Data Retention</h2>

      <p>
        We retain personal information only for as long as reasonably necessary
        for the purposes described in this Privacy Policy.
      </p>

      <p>
        Certain information may be retained for longer periods where required
        for tax, accounting, fraud prevention, dispute resolution, or other
        legal and regulatory purposes.
      </p>

      <h2>Cookies and Similar Technologies</h2>

      <p>
        Our website and mobile application may use cookies, session identifiers,
        local storage, authentication tokens, and similar technologies.
      </p>

      <p>These technologies may be used to:</p>

      <ul>
        <li>Keep customers signed in securely.</li>
        <li>Maintain basket and order information.</li>
        <li>Remember customer preferences.</li>
        <li>Improve website and application performance.</li>
        <li>Protect customer accounts and prevent misuse.</li>
        <li>Understand how our services are used.</li>
      </ul>

      <p>
        You may be able to manage cookies through your browser settings.
        Disabling necessary cookies or storage technologies may prevent parts of
        the website or mobile application from operating correctly.
      </p>

      <h2>Cookies We May Use</h2>

      <table>
        <thead>
          <tr>
            <th>Cookie or Storage Type</th>
            <th>Purpose</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Authentication and session storage</td>
            <td>
              Used to identify signed-in customers and maintain secure sessions.
            </td>
          </tr>

          <tr>
            <td>Shopping basket storage</td>
            <td>
              Used to remember products added to a customer&apos;s basket.
            </td>
          </tr>

          <tr>
            <td>Customer preferences</td>
            <td>
              Used to remember selected settings, language, currency, or display
              preferences where applicable.
            </td>
          </tr>

          <tr>
            <td>Security storage</td>
            <td>
              Used to help prevent fraud, unauthorised access, and misuse.
            </td>
          </tr>

          <tr>
            <td>Analytics</td>
            <td>
              Used to understand application and website usage and improve our
              services, where enabled.
            </td>
          </tr>
        </tbody>
      </table>

      <h2>Marketing Communications</h2>

      <p>
        We may send information about products, services, promotions, or offers
        where you have agreed to receive marketing or where permitted by law.
      </p>

      <p>
        You may stop receiving marketing communications at any time by using an
        unsubscribe option included in the communication or by contacting us at{" "}
        <a href="mailto:sales@bestcateringuk.com">
          sales@bestcateringuk.com
        </a>
        .
      </p>

      <p>
        Stopping marketing communications will not prevent us from sending
        service-related messages concerning your account, orders, or important
        changes to our services.
      </p>

      <h2>Your Data Protection Rights</h2>

      <p>
        Subject to applicable law, you may have the right to:
      </p>

      <ul>
        <li>Request access to personal information held about you.</li>
        <li>Request correction of inaccurate or incomplete information.</li>
        <li>Request deletion of personal information.</li>
        <li>Request restriction of processing.</li>
        <li>Object to certain processing activities.</li>
        <li>Request a portable copy of certain information.</li>
        <li>Withdraw consent where processing is based on consent.</li>
        <li>
          Submit a complaint to the UK Information Commissioner&apos;s Office.
        </li>
      </ul>

      <p>
        To exercise a data protection right, contact us using the details
        provided at the end of this Privacy Policy. We may need to verify your
        identity before completing a request.
      </p>

      <h2>Account and Data Deletion Requests</h2>

      <p>
        Customers may request the closure of their account or deletion of
        eligible personal information by emailing{" "}
        <a href="mailto:sales@bestcateringuk.com">
          sales@bestcateringuk.com
        </a>
        .
      </p>

      <p>
        Some information may continue to be retained where required by law or
        where necessary for accounting, fraud prevention, dispute resolution,
        or the establishment, exercise, or defence of legal claims.
      </p>

      <h2>Children&apos;s Privacy</h2>

      <p>
        The Best Catering Food Service mobile application and website are
        intended for business customers and are not directed at children.
      </p>

      <p>
        We do not knowingly collect personal information from children through
        the application. If you believe that a child has provided personal
        information to us, please contact us so that we can investigate and take
        appropriate action.
      </p>

      <h2>Links to Other Websites</h2>

      <p>
        Our website or mobile application may contain links to third-party
        websites or services. We do not control those third parties and are not
        responsible for their privacy practices.
      </p>

      <p>
        You should review the privacy policy of a third-party website or service
        before providing personal information to it.
      </p>

      <h2>International Data Transfers</h2>

      <p>
        Some service providers may process information outside the United
        Kingdom. Where personal information is transferred internationally, we
        use appropriate safeguards where required by applicable data protection
        laws.
      </p>

      <h2>Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time to reflect changes
        to our services, business practices, or legal requirements.
      </p>

      <p>
        The latest version will be published on this page and the
        &quot;Last updated&quot; date will be changed when material updates are
        made.
      </p>

      <h2>Contacting Us</h2>

      <p>
        If you have any questions about this Privacy Policy or how your personal
        information is handled, you can contact us using the following details:
      </p>

      <ul>
        <li>
          <strong>Company:</strong> Best C. Veg Limited, trading as Best
          Catering Food Service
        </li>

        <li>
          <strong>Address:</strong> Unit 5-9 Leeside Industrial Estate, Garman
          Road, Tottenham, London, N17 0QH
        </li>

        <li>
          <strong>Email:</strong>{" "}
          <a href="mailto:sales@bestcateringuk.com">
            sales@bestcateringuk.com
          </a>
        </li>

        <li>
          <strong>Telephone:</strong>{" "}
          <a href="tel:+442088855594">020 888 555 94</a>
        </li>

        <li>
          <strong>Website:</strong>{" "}
          <a
            href="https://bestcateringuk.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://bestcateringuk.com/
          </a>
        </li>
      </ul>
    </EachFeature>
  );
}

export default PrivacyPolicyContent;